import {Component, inject} from '@angular/core';

import {ModalService} from "@numizmat/services/common";
import {
  DeleteProfileModalComponent
} from "@numizmat/pages/profile-page/components/own-profile/modals/delete-profile-modal/delete-profile-modal.component";

@Component({
    selector: 'nz-delete-account',
    imports: [],
    templateUrl: './delete-account.component.html',
    styleUrl: './delete-account.component.scss'
})
export class DeleteAccountComponent {
  private modalService: ModalService = inject(ModalService);

  protected onOpenDeleteProfileModal(): void {
    this.modalService.open(DeleteProfileModalComponent, {
      scrollable: true
    });
  }
}
